module.exports = __webpack_public_path__ + "static/img/5.3505fde.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/sp/5.png
// module id = dBdW
// module chunks = 0